import { useContext } from 'react'

import { SCAContext } from './SCAContext'

export const useSCA = () => {
  const context = useContext(SCAContext)
  if (!context) {
    throw new Error('useSCA must be used within a SCAProvider')
  }
  return context
}
